import { createContext, useContext, useState, useEffect } from "react";
import { api } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("queen_token") || localStorage.getItem("fyn_token");
    if (token) {
      api
        .get("/auth/me")
        .then((r) => setUser(r.data))
        .catch(() => {
          localStorage.removeItem("queen_token");
          localStorage.removeItem("fyn_token");
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("queen_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (emailOrObj, password, full_name, phone) => {
    let payload;
    if (typeof emailOrObj === "object" && emailOrObj !== null) {
      payload = emailOrObj;
    } else {
      payload = { email: emailOrObj, password, full_name, phone };
    }
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("queen_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("queen_token");
    localStorage.removeItem("fyn_token");
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const isAdmin = user?.role === "admin";

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser, isAdmin, loading, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
